import { statusLadder } from "../../../public/Company/u1/profileStatus";
import { isMemberStatus } from "../../../public/Payment/u1/planFields";

/* Reading one enterprise programme, for the "Tracking as" picker. */

/* Transcribed from checkCredit: a partner program has no ceiling, everything
   else counts down, and the singular is spelled out. Shared with the header's
   own credits label so the two cannot drift. */
export const enterpriseCredits = (enterprise) => {
  if (enterprise?.enterprise_type === "PARTNER_PROGRAM") return "Unlimited Credits";
  const credits = enterprise?.credits;
  if (credits && credits > 1) return `${credits} Credits`;
  if (credits === 1) return `${credits} Credit`;
  return "0 Credit";
};

/* A programme is usually named after its own company, so the company is only
   worth repeating when it differs. */
export const enterpriseCompanyName = (enterprise) => {
  const company = enterprise?.registered_company_name;
  if (!company) return "";
  return company === enterprise?.name ? "" : company;
};

/* The line under the name, in the design's "A · B" shape. */
export const enterpriseSubtitle = (enterprise) =>
  [enterpriseCompanyName(enterprise), enterpriseCredits(enterprise)]
    .filter(Boolean)
    .join(" · ");

/* The dot's tone. A programme with nothing left to spend is the one state
   worth marking, since it cannot order a report — the rest read as normal. */
export const enterpriseTone = (enterprise) => {
  if (enterprise?.enterprise_type === "PARTNER_PROGRAM") return "unlimited";
  return (Number(enterprise?.credits) || 0) > 0 ? "funded" : "empty";
};

export const enterpriseLabel = (enterprise) =>
  enterprise?.name || enterprise?.registered_company_name || "Untitled programme";

/* Who the Partner Program is for. */
export const canUsePartnerProgram = (activeCompany) =>
  Boolean(activeCompany) && isMemberStatus(statusLadder(activeCompany));
